/**
 * The page while a starter turns into a canvas: the brand mark on the ground
 * and one status line that moves on as the wait goes on, so the seconds
 * between the click and the canvas read as work rather than as nothing.
 * Only the starter paths show it; an ordinary canvas open never does.
 */

import { BrandLoader } from "@cohesive/ui-components";
import { useEffect, useState } from "react";

export const LINE_MS = 2400;

export function StarterLoading({ lines }: { lines: readonly string[] }) {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    setIndex(0);
    if (lines.length < 2) return;
    const timer = window.setInterval(
      () => setIndex((i) => Math.min(i + 1, lines.length - 1)),
      LINE_MS,
    );
    return () => window.clearInterval(timer);
  }, [lines]);
  const line = lines[index] ?? lines[0] ?? "";

  return (
    <div
      data-testid="starter-loading"
      className="animate-in fade-in flex min-h-0 flex-1 flex-col items-center justify-center gap-8 px-6 text-center duration-300 motion-reduce:animate-none"
    >
      <BrandLoader className="text-foreground" label={line} />
      <p className="max-w-md text-sm text-muted-foreground">{line}</p>
    </div>
  );
}
